import React from "react";
import ManageSecondaryOrder from "./ManageSecondaryOrder";
import ManageSecondaryOrderV2 from "./ManageSecondaryOrderV2";

const ManageSecondaryOrderContainer = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const manageSecondaryOrderV2 = ConfigDictionary?.manageSecondaryOrderV2 ?? false;

  return manageSecondaryOrderV2 ? (
    <ManageSecondaryOrderV2 />
  ) : (
    <ManageSecondaryOrder />
  );
};

export default ManageSecondaryOrderContainer;
